import { Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useEffect, useState } from '@wordpress/element';
import { API } from '../API';
// import EntidadesItem from '../EntidadesItem';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import ONGs from '../table-ongs/ONGs';
import TableONGsItem from '../table-ongs/TableONGsItem';
import ONGsItem from './ONGsItem';


function SliderEntidades({ displaySearchForm, perSlide }) {

  const apiONGs = new API({
    hasLogo: true
  });
  
  const defaultArgs = {
    posts_per_page: 99,
  }

  const [allONGs, setAllONGs] = useState([]);
  
  useEffect(() => {

    apiONGs.loadContent(defaultArgs).then(response => {
      setAllONGs(response.data);
    });

  }, []);

  return (
    <>

      <Swiper
        className={ displaySearchForm === 'false' ? 'mt-2' : '' }
        modules={[Pagination, A11y, Autoplay]}
        spaceBetween={32}
        autoplay={{
          delay: 2000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true
        }}
        slidesPerView={perSlide}
        slidesPerGroup={perSlide}
        breakpoints={{
          320: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: perSlide,
            slidesPerGroup: perSlide,
            spaceBetween: 16,
          },
        }}
        loop={true}
        navigation
        pagination={{ 
          clickable: true 
        }}
        scrollbar={{ draggable: true }}
      >
        {allONGs.map(item => {
          return (
            <SwiperSlide key={item.id}>
              <ONGsItem id={item.id} title={item.title} logo={item.logo} websiteLink={item.website} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  );
}

export default SliderEntidades;